module.exports = __webpack_public_path__ + "static/media/Untitled-11.afe3ccbd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/make_over/Untitled-11.jpg
// module id = 323
// module chunks = 0